<template>
    <div v-if="tabs.length > 0">
        <lazy-load-component :enabled="lazy" root-margin="0px 0px 0px 0px" @loaded="loadData()">
            <div v-if="tabs.length > 0" class="productCarousel" data-cy="product-carousel">
                <div class="productCarousel__tabs">
                    <h2 v-if="title" class="productCarousel__title">{{ title }}</h2>
                    <pilulka-tabs
                        :active-tab-id="activeTab || 'tab-productCarousel-0'"
                        class="list-tabs list-tabs--classic"
                        :class-tabs="`tabs__header--homepage`"
                    >
                        <pilulka-tab
                            v-for="(tab, index) in tabs"
                            :id="`tab-productCarousel-${index}`"
                            :key="index"
                            :tab-id="`tab-productCarousel-${index}`"
                            :title="tab.name"
                            :url="`#tab-productCarousel-${index}`"
                            :active="activeTab === `tab-productCarousel-${index}`"
                            :default-active="index === 0"
                        >
                            <Carousel
                                :key="index"
                                :products="tab.products"
                                :item-list-name="itemListName"
                                :carousel-name="tab.name"
                                :show-pharmacy-price="showPharmacyPrice"
                                lazy
                                class="slim-carousel--fullWidth"
                            />
                        </pilulka-tab>
                    </pilulka-tabs>
                </div>
            </div>
        </lazy-load-component>
        <SkeletonProductCarouselSkeleton v-if="!loaded && lazy" />
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Carousel from '~/components/elements/Carousel.vue'
import LazyLoadComponent from '~/components/LazyLoadComponent.vue'
import PilulkaTabs from '~/components/elements/PilulkaTabs.vue'
import PilulkaTab from '~/components/elements/PilulkaTab.vue'
import Product from '~/models/Product/Product'

export default {
    components: {
        LazyLoadComponent,
        Carousel,
        PilulkaTabs,
        PilulkaTab,
    },

    props: {
        lazy: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '',
        },
        tabs: {
            type: Array as PropType<{ name: string; products: Product[] }[]>,
            required: true,
        },
        activeTab: {
            type: String,
            default: 'tab-productCarousel-0',
        },
        itemListName: {
            type: String,
            default: '',
        },
        showPharmacyPrice: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            loaded: false,
        }
    },

    mounted() {
        let products: Product[] = []
        this.tabs.forEach((tab: { name: string; products: Product[] }) => {
            products = [...products, ...tab.products]
        })
        refreshFrequentlyActualizedData(products)
    },

    methods: {
        loadData() {
            this.loaded = true
        },
    },
}
</script>

<style lang="scss" scoped>
.productCarousel {
    position: relative;
    max-width: $max-width-container-inside;
    margin: 0 auto 2em auto;

    &__title {
        font-size: 18px;
        color: $color-dark;
        font-weight: 500;
        text-align: left;
        margin-bottom: 0;

        @media (min-width: 768px) {
            float: left;
            margin-right: 10px;
            margin-top: 7px;
            margin-bottom: 0;
        }
    }
}

.title {
    margin-right: 1em;
    font-size: 18px;
    color: $color-dark;
    padding-left: 0;
    font-weight: 500;

    a {
        color: $color-dark;

        &:hover {
            color: $color-cta;
        }
    }

    @media (min-width: 768px) {
        float: left;
        position: relative;
        z-index: 2;
    }
}
</style>
